module.exports = __webpack_public_path__ + "img/ntk_nav_save_g.d5518b97.svg";